import { createContext, useContext, type ReactNode } from "react";
import { mastersApi, type CompanySummary, type MastersReference } from "../lib/api";
import { useLoad } from "../ui/useLoad";

interface CompanyCtx {
  company: CompanySummary;
  ref: MastersReference | null;
  refError: string | null;
  reloadRef: () => Promise<void>;
}
const Ctx = createContext<CompanyCtx | null>(null);

// the open company and the reference data its masters screens share (groups, states, provisions, opening year)
export function CompanyProvider({ company, children }: { company: CompanySummary; children: ReactNode }) {
  const r = useLoad(() => mastersApi.reference(company.id), [company.id]);
  return (
    <Ctx.Provider value={{ company, ref: r.data, refError: r.error?.message ?? null, reloadRef: r.reload }}>
      {r.error && !r.data && (
        <p className="msg err banner" role="alert">Couldn't load this company's setup: {r.error.message}{" "}
          <button className="link" onClick={() => void r.reload()}>Try again</button></p>
      )}
      {children}
    </Ctx.Provider>
  );
}

export function useCompany(): CompanyCtx {
  const c = useContext(Ctx);
  if (!c) throw new Error("useCompany outside a company");
  return c;
}
